<template>
  <a :href="urlPath" class="preview" :class="customClasses" v-if="url">
    <BaseIcon :type="icon" />
    <div class="preview__file-type">
      {{ text }}
    </div>
  </a>

  <router-link :to="urlPath" class="preview" :class="customClasses" v-else>
    <BaseIcon :type="icon" />
    <div class="preview__file-type">
      {{ text }}
    </div>
  </router-link>

</template>

<script>
import BaseIcon from '@base/BaseIcon'
export default {
  name: 'ElementPreview',
  props: {
    type: {
      type: String,
      required: false,
      default: ''
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    url: {
      type: String,
      required: false
    },
    route: {
      type: String,
      required: false
    },
    display: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  components: {
    BaseIcon
  },
  computed: {
    icon () {
      return this.type === 'news' ? 'pencil'
        : this.type === 'document' ? 'sheet'
          : this.type === 'event' ? 'calendar-check'
            : ''
    },
    customClasses () {
      return [
        `preview--${this.type}`,
        `preview--${this.display}`
      ]
    },
    urlPath () {
      return this.url ? this.url
        : !this.url && !this.route ? 'javascript:void(0);'
          : this.route
    }
  }
}
</script>

<style lang="scss">
  .preview {
    @media print {
      border-right: 1px solid black;
    }
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;

    border-radius: .2rem;

    &--medium,
    &--large{
      width: 7rem;
      height: 7rem;
      background-color: white;
    }

    &--news{
      .icon{
        font-size: 3.2rem;
      }
    }

    &--event{
      .icon{
        font-size: 3.2rem;
      }
    }

    &--document{
      .icon{
        font-size: 4rem;
      }
    }

    &--tweet{
      background: url("./_images/croplife_logo_twitter.jpg");
      background-size: cover;
    }

    &--avatar{
      background-image: url("./_images/default-avatar.png");
      background-size: cover;
    }

    &__file-type{
      position: absolute;
      bottom: 1.6rem;
      left: 0;

      color: white;
      font-size: 1rem;
      font-weight: font-weights("bold");
      text-align: center;
      text-transform: uppercase;
      width: 100%;
    }

    .icon{
      @media print {
        color: black;
      }
      color: rgba(black, .4);
    }
  }
</style>
